import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';


export default class PosterManagement {

  #rmp;
  #onAnimatedPosterLoadFn = null;
  #onAnimatedPosterErrorFn = null;
  #onPosterLoadFn = null;
  #onPosterErrorFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
    // poster container
    this.#rmp.dom.poster = FW.createElement('div', 'rmp-poster');
    // poster img
    this.#rmp.dom.posterImg = FW.createElement('img', 'rmp-poster-img');
    this.#adjustPosterFit(this.#rmp.dom.posterImg);
  }

  #onAnimatedPosterLoad() {
    // ffmpeg.exe -i ed-360p.mp4 -ss 00:02:00.000 -t 00:00:10.000 -c:v libwebp -filter:v fps=15,scale=640:-2 -sws_flags bicubic -lossless 1 -loop 0 -preset default -an output_filename.webp
    Logger.print('poster', 'success async loading animated poster image ' + this.#rmp.dom.animatedPosterImg.src);
    this.#rmp.dom.animatedPosterImg.removeEventListener('load', this.#onAnimatedPosterLoadFn);
    this.#rmp.dom.animatedPosterImg.removeEventListener('error', this.#onAnimatedPosterErrorFn);
    if (!this.#rmp.dom.poster.contains(this.#rmp.dom.animatedPosterImg)) {
      this.#rmp.dom.poster.classList.remove('rmp-no-display');
      this.#rmp.dom.poster.appendChild(this.#rmp.dom.animatedPosterImg);
      if (this.#rmp.autoplayAnimatedPoster) {
        this.#rmp.dom.posterImg.style.display = 'none';
        this.#rmp.dom.animatedPosterImg.classList.add('rmp-animated-poster-img', 'rmp-visible');
      } else {
        this.#rmp.dom.animatedPosterImg.style.display = 'none';
        this.#rmp.dom.animatedPosterImg.classList.add('rmp-animated-poster-img');
        this.#rmp.dom.posterImg.classList.add('rmp-poster-img-with-animated', 'rmp-visible');
        this.#rmp.dom.poster.addEventListener('mouseenter', event => {
          if (event) {
            event.stopPropagation();
          }
          this.#rmp.dom.animatedPosterImg.style.display = 'block';
          this.#rmp.dom.animatedPosterImg.classList.add('rmp-visible');
          this.#rmp.dom.posterImg.classList.remove('rmp-visible');
        });
        this.#rmp.dom.poster.addEventListener('mouseleave', event => {
          if (event) {
            event.stopPropagation();
          }
          this.#rmp.dom.animatedPosterImg.classList.remove('rmp-visible');
          this.#rmp.dom.posterImg.classList.add('rmp-visible');
        });
      }
    }
  }

  #onAnimatedPosterError(event) {
    Logger.print('poster', 'failed to load poster image at URI ' + this.#rmp.dom.animatedPosterImg.src);
    this.#rmp.dom.animatedPosterImg.removeEventListener('load', this.#onAnimatedPosterLoadFn);
    this.#rmp.dom.animatedPosterImg.removeEventListener('error', this.#onAnimatedPosterErrorFn);
    this.#rmp.rmpUtils.warning(1002, event);
  }

  #onPosterLoad() {
    Logger.print('poster', 'success async loading poster image ' + this.#rmp.dom.posterImg.src);
    this.#rmp.dom.posterImg.removeEventListener('load', this.#onPosterLoadFn);
    this.#rmp.dom.posterImg.removeEventListener('error', this.#onPosterErrorFn);
    if (!this.#rmp.dom.poster.contains(this.#rmp.dom.posterImg)) {
      this.#rmp.dom.poster.appendChild(this.#rmp.dom.posterImg);
    }
  }

  #onPosterError(event) {
    Logger.print('poster', 'failed to load poster image at URI ' + this.#rmp.dom.posterImg.src);
    this.#rmp.dom.posterImg.removeEventListener('load', this.#onPosterLoadFn);
    this.#rmp.dom.posterImg.removeEventListener('error', this.#onPosterErrorFn);
    this.#rmp.rmpUtils.warning(1001, event);
  }

  #adjustPosterFit(element) {
    if (FW.cssPropertySupport('objectFit')) {
      switch (this.#rmp.posterScaleMode) {
        case 'letterbox':
          element.classList.add('rmp-object-fit-contain');
          break;
        case 'zoom':
          element.classList.add('rmp-object-fit-cover');
          break;
        case 'stretch':
          element.classList.add('rmp-object-fit-fill');
          break;
        case 'none':
          element.classList.add('rmp-object-fit-none');
          break;
        default:
          element.classList.add('rmp-object-fit-contain');
          break;
      }
    } else {
      element.classList.add('rmp-poster-img-no-object-fit');
    }
  }

  filterPoster() {
    // assign poster
    if (this.#rmp.autoplay) {
      this.#rmp.posterUri = '';
      if (this.#rmp.contentMetadata.endOfVideoPoster.length === 0 &&
        this.#rmp.contentMetadata.poster.length > 0) {
        this.#rmp.contentMetadata.endOfVideoPoster = this.#rmp.contentMetadata.poster;
      }
    } else {
      if (this.#rmp.contentMetadata.poster.length > 0) {
        this.#rmp.posterUri = FW.getPoster(this.#rmp.contentMetadata.poster);
      }
    }
    Logger.print('poster',
      'validated poster is ' + this.#rmp.posterUri + ' for devicePixelRatio ' + Env.devicePixelRatio);
    // assign endOfVideoPoster 
    if (this.#rmp.contentMetadata.endOfVideoPoster.length > 0) {
      this.#rmp.endOfVideoPoster = FW.getPoster(this.#rmp.contentMetadata.endOfVideoPoster);
    }
    Logger.print('poster',
      'validated endOfVideoPoster is ' + this.#rmp.endOfVideoPoster + ' for devicePixelRatio ' + Env.devicePixelRatio);
  }

  wirePosterLoadEvents() {
    this.#onPosterLoadFn = this.#onPosterLoad.bind(this);
    this.#onPosterErrorFn = this.#onPosterError.bind(this);
    this.#rmp.dom.posterImg.addEventListener('load', this.#onPosterLoadFn);
    this.#rmp.dom.posterImg.addEventListener('error', this.#onPosterErrorFn);
  }

  unwirePosterLoadEvents() {
    this.#rmp.dom.posterImg.removeEventListener('load', this.#onPosterLoadFn);
    this.#rmp.dom.posterImg.removeEventListener('error', this.#onPosterErrorFn);
  }

  initAnimatedPoster() {
    this.#rmp.dom.animatedPosterImg = FW.createElement('img', 'rmp-poster-img');
    this.#rmp.dom.animatedPosterImg.alt = '';
    this.#adjustPosterFit(this.#rmp.dom.animatedPosterImg);
    this.#onAnimatedPosterLoadFn = this.#onAnimatedPosterLoad.bind(this);
    this.#onAnimatedPosterErrorFn = this.#onAnimatedPosterError.bind(this);
    this.#rmp.dom.animatedPosterImg.addEventListener('load', this.#onAnimatedPosterLoadFn);
    this.#rmp.dom.animatedPosterImg.addEventListener('error', this.#onAnimatedPosterErrorFn);
    this.#rmp.dom.animatedPosterImg.src = this.#rmp.contentMetadata.animatedPoster;
  }

  init() {
    Logger.print('poster', 'init called for PosterManagement instance');
    if (!this.#rmp.dom.content.contains(this.#rmp.dom.poster)) {
      this.#rmp.dom.content.appendChild(this.#rmp.dom.poster);
    }
    // guard again a bug in react back/forth button Chrome where this.#rmp.labels becomes undefined
    if (this.#rmp.backgroundColor) {
      this.#rmp.dom.poster.style.backgroundColor = '#' + this.#rmp.backgroundColor;
    }
    this.#rmp.dom.posterImg.alt = '';
    // Poster load events
    this.wirePosterLoadEvents();

    // animated poster
    if (this.#rmp.contentMetadata.animatedPoster) {
      this.initAnimatedPoster();
    }
    let src;
    if (this.#rmp.posterUri !== '') {
      src = this.#rmp.posterUri;
    } else if (this.#rmp.hideInitialBlackFrameWhenNoPoster) {
      this.#rmp.dom.poster.classList.add('rmp-no-display');
    } else {
      src = FW.blackFrame;
    }
    if (src) {
      if (!this.#rmp.contentMetadata.endOfVideoPoster[0]) {
        this.#rmp.contentMetadata.endOfVideoPoster = [src];
      }
      if (this.#rmp.autoplay &&
        !(this.#rmp.audioOnlyUseVideoLayout || this.#rmp.playlistAudioOnly || this.#rmp.relatedAudioOnly)) {
        this.#rmp.hidePoster();
      } else {
        this.#rmp.dom.posterImg.src = src;
      }
    }
  }

}
